import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import { useTheme } from '../../context/ThemeContext';

/**
 * Footer Component
 * 
 * Displays the application footer with important links
 * @returns {JSX.Element} Footer component
 */
const Footer = () => {
  const [version, setVersion] = useState(null);
  const { themeColors } = useTheme();

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const res = await api.get('/version');
        if (isMounted && res?.data) {
          const v = res.data.version || res.data.serverVersion || null;
          const sha = res.data.commit ? String(res.data.commit).slice(0, 7) : null;
          setVersion(v ? `${v}${sha ? ` • ${sha}` : ''}` : null);
        }
      } catch (e) {
        // silently ignore
      }
    })();
    return () => { isMounted = false; };
  }, []);

  return (
    <footer 
      className="backdrop-blur-sm border-t border-[var(--border-primary)]/50 py-3 text-center"
      style={{
        background: `linear-gradient(to bottom right, ${themeColors.primary50}, ${themeColors.primary100})`,
      }}
    >
      <div className="container mx-auto px-4">
        <div className="text-sm text-gray-600 mb-2">
          <Link to="/about" className="text-gray-600 hover:text-indigo-600 mx-2">About</Link>
          <span className="text-gray-400">•</span>
          <Link to="/mission" className="text-gray-600 hover:text-indigo-600 mx-2">Our Mission</Link>
          <span className="text-gray-400">•</span>
          <Link to="/docs" className="text-gray-600 hover:text-indigo-600 mx-2">Docs</Link>
          <span className="text-gray-400">•</span>
          <Link to="/forum" className="text-gray-600 hover:text-indigo-600 mx-2">Forum</Link>
          <span className="text-gray-400">•</span>
          <Link to="/privacy" className="text-gray-600 hover:text-indigo-600 mx-2">Privacy Policy</Link>
          <span className="text-gray-400">•</span>
          <Link to="/data-retention" className="text-gray-600 hover:text-indigo-600 mx-2">Data Retention</Link>
        </div>
        <div className="text-xs text-gray-500">
          © 2024 O Industries LLC. All rights reserved.
          {version && <span className="ml-2 text-gray-400">v{version}</span>}
        </div>
      </div>
    </footer>
  );
};

export default Footer; 